import { Component, OnInit, HostListener } from '@angular/core';
import { AuthService } from '../../core/service/authentication/auth.service';
import { ModalService } from '../../core/service/modal/modal.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../core/service/loader/loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isLoggedIn = false;
  isMobile = false;
  isMenuOpen = false;
  isProcessing = false;
  isTryMode: boolean = environment.IS_TRY_MODE;

  constructor(
    private authService: AuthService,
    private modalService: ModalService,
    private router: Router,
    private loader: LoaderService
  ) {
    this.checkIfMobile();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkIfMobile();
  }

  toggleMobileMenu() {
    this.isMenuOpen = !this.isMenuOpen; // Cambia lo stato del menu mobile
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  handleMenuAction(action?: string): void {
    switch (action) {
      case 'login':
        this.openLoginModal();
        break;
      case 'register':
        this.openRegisterModal();
        break;
      case 'logout':
        this.logout();
        break;
      default:
        break; // Per altre voci (come "Profile"), non serve fare nulla.
    }

    // Chiudi il menu dopo aver eseguito l'azione
    this.toggleMobileMenu();
  }

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isAuthenticated();

    this.checkIfMobile();
  }

  openLoginModal() {
    this.modalService.openModal('login');
  }

  openRegisterModal() {
    this.modalService.openModal('register');
  }

  hideRegisterBanner() {
    const activeBannerElement = document.querySelector('#registerBanner');
    activeBannerElement?.remove();
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.toggleMobileMenu();
    }
  }
  logout(): void {
    this.loader.showLoader();

    this.isLoggedIn = false;
    this.authService.clearAuth();

    this.router.navigateByUrl('');
    this.loader.hideLoader();
  }
}
